import Dicom from './parsers.dicom';
import Mgh from './parsers.mgh';
import Nifti from './parsers.nifti';
import Nrrd from './parsers.nrrd';

export { Dicom as DicomParser, Mgh as MghParser, Nifti as NiftiParser, Nrrd as NrrdParser };
